import { call, select, put, takeEvery, all } from "redux-saga/effects";
import {
  default as requestWithSubTenantIfNeeded,
  currentSubTenantSelector,
  currentTenantSelector,
} from "../requestWithSubTenantIfNeeded";
import * as actions from "./networksBeaconsGetActions";
import {
  SOCKET_EVENT_DEPLOY_SUCCESS,
  SOCKET_EVENT_DEPLOY_CUSTOM_SUCCESS,
  SOCKET_EVENT_DESTROY_SUCCESS,
  SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS,
} from "../networksBeaconsGet/networksBeaconsGetActions";

function* networksBeaconsGet(action) {
  try {
    let tenantId = yield select(currentSubTenantSelector);

    if (!tenantId) {
      tenantId = yield select(currentTenantSelector);
    }

    if (
      action.type !== actions.NETWORKS_BEACONS_GET_REQUEST &&
      action.data.networkBeacon.tenantId !== tenantId
    ) {
      return;
    }

    let response = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "networks/beacons"
    );

    yield put(
      actions.requestSuccess(
        {
          networkBeacons: response.data.networkBeacons,
        },
        tenantId
      )
    );
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield all([
    takeEvery(
      [
        actions.NETWORKS_BEACONS_GET_REQUEST,
        SOCKET_EVENT_DEPLOY_SUCCESS,
        SOCKET_EVENT_DEPLOY_CUSTOM_SUCCESS,
        SOCKET_EVENT_DESTROY_SUCCESS,
        SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS,
      ],
      networksBeaconsGet
    ),
  ]);
}

export default saga;
